import React, { useRef, useEffect, useState } from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import OpenCloseIcon from "../Icons/OpenClose";
import styles from "./style.module.scss";

export default function ExpansionPanel({ title, content }) {
  const [display, setDisplay] = useState(false);
  const [height, setHeight] = useState(null);
  const ref = useRef(null);

  useEffect(() => {
    setHeight(ref.current.scrollHeight);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleResize = () => {
    setHeight(ref.current.scrollHeight);
  };

  return (
    <div className={styles.container}>
      <div className={styles.title} onClick={() => setDisplay(!display)}>
        <span>{title}</span>
        <OpenCloseIcon closed={display} />
      </div>
      <div
        className={cx({
          [styles.expansion]: true,
          [styles.expanded]: display
        })}
        ref={ref}
        style={{ height: display ? `${height}px` : 0 }}
      >
        {content}
      </div>
    </div>
  );
}

ExpansionPanel.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired
};
